import { render, staticRenderFns } from "./DashboardBuilder.vue?vue&type=template&id=3cf9ea36&"
import script from "./DashboardBuilder.vue?vue&type=script&lang=js&"
export * from "./DashboardBuilder.vue?vue&type=script&lang=js&"
import style0 from "./DashboardBuilder.vue?vue&type=style&index=0&id=3cf9ea36&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports